import * as React from 'react';
import { isEmpty, get } from 'lodash';
import { getItemState } from 'utils/cartUtils';
import CartActionButton from './CartActionButton';
import { CartItemState } from '@rome/response/cart/enums/CartItemState';
import { CartItemParent } from 'components/CartItem/CartItem';
export default class CartActions extends React.Component {
    constructor(props) {
        super(props);
        this.handleAction = (action) => () => {
            const { cartItem } = this.props;
            const { isMarketPlace = false, listingIds } = this.props;
            const listingId = isMarketPlace ? listingIds : get(cartItem, 'listingId');
            action && typeof action === 'function' && action(listingId, isMarketPlace);
        };
    }
    render() {
        const buttons = [];
        const { parent, tabIndexPrefix = 0, isSFLItem = false, sflEnabled, isMarketPlace = false, moveSFLToCart, removeSFLItem, moveToSFL, removeCartConfirmation, removeCartItem, moveToWishlist, moveItemToCart, className } = this.props;
        const { cartItem } = this.props;
        if (parent === CartItemParent.CART) {
            if (isSFLItem) {
                const itemState = isEmpty(cartItem) ? null : getItemState(parent, cartItem);
                if (itemState === CartItemState.BUYABLE || isMarketPlace) {
                    buttons.push({
                        onClick: this.handleAction(moveSFLToCart),
                        tabIndex: `${tabIndexPrefix}2`,
                        tag: 'sfl-item-cart',
                        buttonText: 'sflToCart'
                    });
                    buttons.push({
                        onClick: this.handleAction(removeSFLItem),
                        tabIndex: `${tabIndexPrefix}3`,
                        tag: 'remove-from-sfl',
                        buttonText: isMarketPlace ? 'removeBasketText' : 'removeText'
                    });
                }
                else {
                    buttons.push({
                        onClick: this.handleAction(removeSFLItem),
                        tabIndex: `${tabIndexPrefix}2`,
                        tag: 'remove-from-sfl',
                        buttonText: isMarketPlace ? 'removeBasketText' : 'removeText'
                    });
                }
            }
            else if (sflEnabled) {
                // TODO: We're explicitly checking cartItem being present and
                // assuming it's false otherwise. Not sure how robust this
                // assumption is.
                // We're having to do this here because cartItem is optional
                // for this component (in case of groceries).
                const isASMItem = isEmpty(cartItem) ? false : cartItem.reservationDetails;
                if (!isASMItem) {
                    buttons.push({
                        onClick: this.handleAction(moveToSFL),
                        tabIndex: `${tabIndexPrefix}2`,
                        tag: 'cart-item-sfl',
                        buttonText: 'cartToSFL'
                    });
                }
                buttons.push({
                    onClick: this.handleAction(isMarketPlace ? removeCartConfirmation : removeCartItem),
                    tabIndex: `${tabIndexPrefix}3`,
                    tag: 'remove-from-cart',
                    buttonText: isMarketPlace ? 'removeBasketText' : 'removeText'
                });
            }
            else {
                if (!isMarketPlace) {
                    buttons.push({
                        onClick: this.handleAction(moveToWishlist),
                        tabIndex: `${tabIndexPrefix}2`,
                        tag: 'cart-item-wishlist',
                        buttonText: 'cartToWishlist'
                    });
                }
                buttons.push({
                    onClick: this.handleAction(isMarketPlace ? removeCartConfirmation : removeCartItem),
                    tabIndex: `${tabIndexPrefix}3`,
                    tag: 'remove-from-cart',
                    buttonText: isMarketPlace ? 'removeBasketText' : 'removeText'
                });
            }
        }
        else if (parent === CartItemParent.CHECKOUT) {
            buttons.push({
                onClick: this.handleAction(moveItemToCart),
                tabIndex: `${tabIndexPrefix}2`,
                tag: 'move-to-cart',
                buttonText: 'removeText'
            });
        }
        return <CartActionButton buttons={buttons} isMarketPlace={isMarketPlace} className={className}/>;
    }
}
